export function initialsFromLabel(label, explicit) {
    const t = explicit === null || explicit === void 0 ? void 0 : explicit.trim();
    if (t)
        return t.slice(0, 2).toUpperCase();
    const parts = label.trim().split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
        const a = parts[0][0];
        const b = parts[parts.length - 1][0];
        return `${a}${b}`.toUpperCase().slice(0, 2);
    }
    return label.trim().slice(0, 2).toUpperCase() || '?';
}
export function filterSearchSelectOptions(options, q) {
    const n = q.trim().toLowerCase();
    if (!n)
        return options;
    return options.filter((o) => {
        var _a;
        const hay = `${o.label} ${(_a = o.sub) !== null && _a !== void 0 ? _a : ''} ${o.value}`.toLowerCase();
        return hay.includes(n);
    });
}
